// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown___279Bg","trigger":"trigger___1ouv8","triangle-icon":"triangle-icon___356Vf","pagination":"pagination___ShdP-"};